module.exports = __webpack_public_path__ + "img/goods16.eb4ecfa2.jpg";